import { render, staticRenderFns } from "./uxUGCGameplayGroupTestPanel.vue?vue&type=template&id=389d2470&scoped=true&"
import script from "./uxUGCGameplayGroupTestPanel.vue?vue&type=script&lang=js&"
export * from "./uxUGCGameplayGroupTestPanel.vue?vue&type=script&lang=js&"
import style0 from "./uxUGCGameplayGroupTestPanel.vue?vue&type=style&index=0&id=389d2470&lang=less&scoped=true&"
import style1 from "./uxUGCGameplayGroupTestPanel.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389d2470",
  null
  
)

export default component.exports